import { is } from "ramda";
import {
    REMOVE_EMAIL_ATTACHMENT,
    SET_EMAIL_ATTACHMENTS,
    SET_PO_VENDOR_EMAIL,
    SET_SEND_PO_VENDOR_EMAIL
} from "./PoVendorEmailType";

const initialState = {
    poVendorEmailDetails: {},
    isPoVendorEmailSent: null,
    attachments: {
        loading: false,
        list: [],
      },
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_PO_VENDOR_EMAIL:
            return {
                ...state,
                poVendorEmailDetails: action.poVendorEmailDetails,
            };
        case SET_SEND_PO_VENDOR_EMAIL:
            return {
                ...state,
                isPoVendorEmailSent: action.isPoVendorEmailSent,
            };
        case SET_EMAIL_ATTACHMENTS:
           const fileList = action.value;
            return {
                ...state,
                attachments: {
                  ...state.attachments,
                  list: [...fileList],
                },
              };
        case REMOVE_EMAIL_ATTACHMENT:
            const index = action.value;
            const newArr = state.attachments.list.slice();
              newArr.splice(index, 1);
              return {
                ...state,
                attachments: {
                  ...state.attachments,
                  list: [...newArr],
                },
              };
        default:
            return state;
    }
};

export default reducer;
